import { css } from 'styled-components';
import { TypographyName, getTypography, getSpacing, SpacingName } from '../../theme';
export const suggestionList = _ref => {
  let {
    theme
  } = _ref;
  return css(["top:auto;position:absolute;background-color:", ";border:1px solid ", ";border-top:0;margin-top:-6px;left:0;right:0;border-bottom-left-radius:6px;border-bottom-right-radius:6px;overflow:hidden;"], theme.palettes.neutrals.lightest, theme.palettes.neutrals.medium);
};
export const suggestion = _ref2 => {
  let {
    theme,
    $isHighlighted
  } = _ref2;
  return css(["", " ", " cursor:pointer;", ""], getTypography(theme, TypographyName.SMALL), getSpacing.padding(theme, SpacingName.SMALLER), $isHighlighted ? `
    background-color: ${theme.palettes.neutrals.lighter};
  ` : '');
};
export const suggestionError = _ref3 => {
  let {
    theme
  } = _ref3;
  return css(["", " ", " font-style:italic;"], getTypography(theme, TypographyName.SMALL), getSpacing.padding(theme, SpacingName.SMALLER));
};
//# sourceMappingURL=AutoComplete.style.js.map